import React from 'react';
import { ModelReview } from '../services/orderService';

interface ReviewListProps {
  reviews: ModelReview[];
  isLoading: boolean;
}

const ReviewList: React.FC<ReviewListProps> = ({ reviews, isLoading }) => {
  if (isLoading) {
    return (
      <div className="animate-pulse space-y-3">
        {[1, 2].map((i) => (
          <div key={i} className="bg-white rounded-lg p-3">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
              <div className="flex-1">
                <div className="h-3 bg-gray-200 rounded w-1/3"></div>
                <div className="h-2 bg-gray-200 rounded w-1/4 mt-1"></div>
              </div>
            </div>
            <div className="space-y-1.5">
              <div className="h-3 bg-gray-200 rounded w-full"></div>
              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (reviews.length === 0) {
    return (
      <div className="text-center py-4 bg-white rounded-lg">
        <div className="w-12 h-12 mx-auto mb-3 text-gray-300">
          <i className="fas fa-star text-3xl"></i>
        </div>
        <h3 className="text-base font-medium text-gray-900 mb-1">No Reviews Yet</h3>
        <p className="text-sm text-gray-500">Be the first one to review this model</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {reviews.map((review, index) => (
        <div key={index} className="bg-white rounded-lg p-3 shadow-sm">
          {/* Review Header */}
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-minto-50 rounded-full flex items-center justify-center">
                <span className="text-minto-600 text-sm font-medium">
                  {review.customerName.charAt(0).toUpperCase()}
                </span>
              </div>
              <div>
                <h4 className="text-sm font-medium text-gray-900 line-clamp-1">{review.customerName}</h4>
                <div className="flex items-center gap-1">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`fas fa-star text-xs ${
                          i < review.rating ? 'text-yellow-400' : 'text-gray-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">
                    {new Date(review.createdAt).toLocaleDateString('en-IN', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Review Content */}
          <div className="space-y-2">
            <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
              {review.comment}
            </p>
            {review.photoUrl && (
              <div className="mt-2">
                <img
                  src={`https://mintorepairs.com/uploads/assets/${review.photoUrl}`}
                  alt="Review"
                  className="rounded-lg max-h-32 object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewList; 